import React from 'react'
import PropTypes from 'prop-types'

import FormManager from 'src/core/gd-form/common/form-manager'

import CustomFieldAddFormProto from "../../add-form-proto"
import CustomFieldLeftPanel from "../../common/panel/form-left-panel"
import CustomFieldPreview from "../../common/form-preview"
import CustomFieldRightPanel from "core/fields/custom/common/panel/form-right-panel"
import FieldView from "../../../../fields3/render/view"
import FieldsFactory from "../../../../fields3/fields-factory"
import {FieldType} from "../../../../fields3/field-type"

export default class ColorCustomFieldForm extends CustomFieldAddFormProto {

    static propTypes = {
        organizationId  : PropTypes.string.isRequired,
        customField     : PropTypes.object,

        onSubmit        : PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props)

        this.type = gd.const.customFields.type.COLOR
        this.form = new FormManager(this.formStructure, this.initFormData)
    }

    onSubmit(result) {
        result.name = result.name.trim()
        result.type = gd.const.customFields.type.COLOR

        result.params = {
            scope: result.scope
        };

        this.props.onSubmit(result)
    }

    render() {
        const field3 = FieldsFactory.get({
            fieldId : 'color',
            label   : 'Color',
            type    : FieldType.COLOR
        })

        return (
            <React.Fragment>
                <CustomFieldLeftPanel parent={this}>
                    <CustomFieldPreview noPadding={true}>
                        <div className="gd-field-color form-new disabled m-t-5">
                            <div className="field-holder">
                                <FieldView field={field3} model={{color: 1}}/>
                            </div>
                        </div>
                    </CustomFieldPreview>
                </CustomFieldLeftPanel>
                <CustomFieldRightPanel parent={this}/>
            </React.Fragment>
        )
    }
}
